module.exports = __webpack_public_path__ + "static/media/fl_solution_logo.b298b393.png";